<div class="dms-dashboard-page" fxLayout="column">
    <div
        class="dms-dashboard-bg"
        [style.background-image]="backgroundImageStyle"
        [style.background-color]="backgroundImageStyle ? null : '#ffffff'"
        [style.opacity]="backgroundImageStyle ? (bgImageOpacityPct / 100) : 1"></div>
    <div class="dms-dashboard-content" fxLayout="column">
        <div class="row">
            <div class="col-12">
                <div class="" [style.--dms-card-bg]="cardBgRgba" fxLayout="column">
                    <div class="dms-dashboard-toolbar" fxLayout="row wrap" fxLayoutAlign="space-between center">
                        <div class="dms-dashboard-toolbar__group" fxLayout="row wrap" fxLayoutAlign="start center">
                            <div class="searchbox">
                                <i-feather name="search"></i-feather>
                                <input 
                                    id="txtSearchQuery" 
                                    type="text" 
                                    [placeholder]="'SEARCH' | translate"
                                    class="form-control form-control-sm ms-2" 
                                    aria-controls="tickets-table" 
                                    [(ngModel)]="searchString" 
                                    (keydown.enter)="doSearch($event)">
                            </div>
                            <div class="dropdown">
                                <ng-select 
                                    [placeholder]="'FILTER_BY_USER' | translate"
                                    [items]="allUsers" 
                                    bindLabel="fullName" 
                                    bindValue="id" 
                                    [(ngModel)]="selectedUserId" 
                                    (ngModelChange)="filterByUser(selectedUserId)" 
                                    (clear)="filterByUser(null)" 
                                    [clearable]="true">
                                </ng-select>
                            </div>
                            <div class="dropdown">
                                <ng-select 
                                    [placeholder]="'FILTER_BY_TYPE' | translate"
                                    [items]="automationsList" 
                                    bindLabel="name" 
                                    bindValue="id" 
                                    [(ngModel)]="selectedAutomationId" 
                                    (ngModelChange)="filterByAutomation(selectedAutomationId)" 
                                    (clear)="filterByAutomation(null)" 
                                    [clearable]="true">
                                </ng-select>
                            </div>
                            <button type="button" class="gray-button dms-dashboard-toolbar__button" (click)="toggleWeekView()">
                                {{ showNextWeek ? ('VIEW_THIS_WEEK' | translate) : ('VIEW_NEXT_WEEK' | translate) }}
                            </button>
                            <button
                                type="button"
                                class="gray-button dms-dashboard-toolbar__button"
                                [disabled]="isCheckingCampaignsWithNoCheck || !canCheckCampaignsWithNoCheck"
                                (click)="onCampaignsWithNoCheckClick()">
                                {{ isCheckingCampaignsWithNoCheck ? ('CHECKING_DOTS' | translate) : campaignsWithNoCheckButtonLabel }}
                            </button>
                            <button type="button" class="gray-button dms-dashboard-toolbar__button" [disabled]="isCheckingClientsWithNoCall || !canCheckCampaignsWithNoCheck" (click)="onClientsWithNoCallClick()">
                                {{ isCheckingClientsWithNoCall ? ('CHECKING_DOTS' | translate) : clientsWithNoCallButtonLabel }}
                            </button>
                            <button type="button" class="gray-button dms-dashboard-toolbar__button" [disabled]="isCheckingOverdueCalls || !canCheckCampaignsWithNoCheck" (click)="onOverdueCallsClick()">
                                {{ isCheckingOverdueCalls ? ('CHECKING_DOTS' | translate) : overdueCallsButtonLabel }}
                            </button>
                        </div>
                        <div class="dms-dashboard-toolbar__group dms-dashboard-toolbar__group--actions" fxLayout="row wrap" fxLayoutAlign="end center">
                            <button type="button" class="blue-button dms-dashboard-toolbar__button" (click)="onAddTaskClick('add')">{{ 'ADD_TASK' | translate }}</button>
                        </div>
                    </div>

                    <div class="row" *ngIf="showNextWeek">
                        <div class="alert alert-danger dms-dashboard-alert" role="alert">
                            <h3 class="dms-dashboard-alert__title">{{ 'NEXT_WEEK' | translate }}</h3>
                        </div>
                    </div>
                    
                    <div class="row taskrow">
                        <div class="col task-column" [style.background-color]="taskcolBgRgba" fxLayout="column">
                            <div class="taskHeader" [style.color]="taskHeaderColor">{{ 'OVERDUE' | translate }} ({{ overdueTasksData.length }})</div>
                            <div class="taskcol">
                                <ul>
                                    <li *ngFor="let task of overdueTasksData" [ngClass]="{'redalert': $any(task).isRedAlert === true, 'audit-needed': $any(task).isAuditNeeded === true && isCampaignCheckTitle(task.title)}" (click)="viewTask(task)">
                                        <div class="title">{{ task.title }}</div>
                                        <div class="audit-needed-label" *ngIf="$any(task).isAuditNeeded === true && isCampaignCheckTitle(task.title)">{{ 'AUDIT_NEEDED' | translate }}</div>
                                        <div *ngIf="task.clientName && task.clientName > ''" class="client">{{ task.clientName }} <a target="_blank" href="/pages/client-details/{{ task.clientId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div *ngIf="task.campaignName && task.campaignName > ''" class="campaign">{{ task.campaignName }} <a target="_blank" href="/pages/campaign-details/{{ task.campaignId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div class="small user" *ngIf="!myTasks">{{ task.assignedUserName }}</div>
                                        <div class="small date" [ngClass]="{'overdue': isOverdue(task.dueDate)}">{{ task.dueDate | date: 'mediumDate' }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col task-column" [style.background-color]="taskcolBgRgba" *ngFor="let day of weekDayKeys" fxLayout="column">
                            <div class="taskHeader" [style.color]="taskHeaderColor">{{ day | translate }} ({{ getTaskCountForDay(day) }})</div>
                            <div class="taskcol">
                                <ul>
                                    <li *ngFor="let task of thisWeekTasksData" [ngClass]="{'d-none': !isTaskDueOnDay(task.dueDate, day), 'redalert': $any(task).isRedAlert === true, 'audit-needed': $any(task).isAuditNeeded === true && isCampaignCheckTitle(task.title)}" (click)="viewTask(task)">
                                        <div class="title">{{ task.title }}</div>
                                        <div class="audit-needed-label" *ngIf="$any(task).isAuditNeeded === true && isCampaignCheckTitle(task.title)">{{ 'AUDIT_NEEDED' | translate }}</div>
                                        <div *ngIf="task.clientName && task.clientName > ''" class="client">{{ task.clientName }} <a target="_blank" href="/pages/client-details/{{ task.clientId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div *ngIf="task.campaignName && task.campaignName > ''" class="campaign">{{ task.campaignName }} <a target="_blank" href="/pages/campaign-details/{{ task.campaignId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div class="small user" *ngIf="!myTasks">{{ task.assignedUserName }}</div>
                                        <div class="small date" [ngClass]="{'overdue': isOverdue(task.dueDate)}">{{ task.dueDate | date: 'mediumDate' }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col task-column" [style.background-color]="taskcolBgRgba" fxLayout="column">
                            <div class="taskHeader" [style.color]="taskHeaderColor">{{ 'FUTURE' | translate }} ({{ futureTasksData.length }})</div>
                            <div class="taskcol">
                                <ul>
                                    <li *ngFor="let task of futureTasksData" [ngClass]="{'redalert': $any(task).isRedAlert === true, 'audit-needed': $any(task).isAuditNeeded === true && isCampaignCheckTitle(task.title)}" (click)="viewTask(task)">
                                        <div class="title">{{ task.title }}</div>
                                        <div class="audit-needed-label" *ngIf="$any(task).isAuditNeeded === true && isCampaignCheckTitle(task.title)">{{ 'AUDIT_NEEDED' | translate }}</div>
                                        <div *ngIf="task.clientName && task.clientName > ''" class="client">{{ task.clientName }} <a target="_blank" href="/pages/client-details/{{ task.clientId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div *ngIf="task.campaignName && task.campaignName > ''" class="campaign">{{ task.campaignName }} <a target="_blank" href="/pages/campaign-details/{{ task.campaignId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div class="small user" *ngIf="!myTasks">{{ task.assignedUserName }}</div>
                                        <div class="small date" [ngClass]="{'overdue': isOverdue(task.dueDate)}">{{ task.dueDate | date: 'mediumDate' }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> <!-- end col -->
            </div> <!-- end row -->
        </div>
    </div>
</div>

<ng-template #campaignsNoCheckModal let-modal>
    <div class="modal-box add-note-modal" cdkDrag>
        <div class="modal-header">
            <h5 class="modal-title">{{ 'CAMPAIGNS_WITH_NO_CHECK' | translate }}</h5>
            <button type="button" class="btn-close" [attr.aria-label]="'CLOSE' | translate" (click)="modal.dismiss()"></button>
        </div>

        <div class="modal-body">
            <div *ngIf="campaignsWithNoCheckError" class="alert alert-warning mb-0" role="alert">
                {{ campaignsWithNoCheckError }}
            </div>

            <div *ngIf="!campaignsWithNoCheckError && campaignsWithNoCheckRows.length === 0" class="text-muted">
                {{ 'NO_MISSING_CHECKS' | translate }}
            </div>

            <div *ngIf="!campaignsWithNoCheckError && campaignsWithNoCheckRows.length > 0" class="table-responsive">
                <table class="table-sm align-middle mb-0">
                    <thead>
                        <tr>
                            <th>{{ 'CAMPAIGN' | translate }}</th>
                            <th>{{ 'CLIENT' | translate }}</th>
                            <th>{{ 'STAGE' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of campaignsWithNoCheckRows">
                            <td>
                                <span>{{ row.campaignName }}</span>
                                <a *ngIf="row.campaignId" target="_blank" href="/pages/campaign-details/{{ row.campaignId }}" class="ms-1">
                                    <i class="fas fa-external-link-alt"></i>
                                </a>
                            </td>
                            <td>
                                <span>{{ row.clientName }}</span>
                                <a *ngIf="row.clientId" target="_blank" href="/pages/client-details/{{ row.clientId }}" class="ms-1">
                                    <i class="fas fa-external-link-alt"></i>
                                </a>
                            </td>
                            <td>{{ row.stageTitle }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="modal.close()">{{ 'CLOSE' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #clientsNoCallModal let-modal>
    <div class="modal-box add-note-modal" cdkDrag>
        <div class="modal-header">
            <h5 class="modal-title">{{ 'CLIENTS_WITH_NO_CALL' | translate }}</h5>
            <button type="button" class="btn-close" [attr.aria-label]="'CLOSE' | translate" (click)="modal.dismiss()"></button>
        </div>
        <div class="modal-body">
            <div *ngIf="clientsWithNoCallError" class="alert alert-warning mb-0">{{ clientsWithNoCallError }}</div>
            <div *ngIf="!clientsWithNoCallError && clientsWithNoCallRows.length === 0" class="text-muted">{{ 'NO_CLIENTS_WITH_NO_CALL' | translate }}</div>
            <div *ngIf="!clientsWithNoCallError && clientsWithNoCallRows.length > 0" class="table-responsive">
                <table class="table-sm align-middle mb-0">
                    <thead><tr><th>{{ 'CLIENT' | translate }}</th><th>{{ 'CAMPAIGNS' | translate }}</th></tr></thead>
                    <tbody><tr *ngFor="let row of clientsWithNoCallRows">
                        <td><span>{{ row.clientName }}</span><a *ngIf="row.clientId" target="_blank" href="/pages/client-details/{{ row.clientId }}" class="ms-1"><i class="fas fa-external-link-alt"></i></a></td>
                        <td>{{ row.campaignCount }}</td>
                    </tr></tbody>
                </table>
            </div>
        </div>
        <div class="modal-footer"><button type="button" class="btn btn-outline-secondary" (click)="modal.close()">{{ 'CLOSE' | translate }}</button></div>
    </div>
</ng-template>

<ng-template #overdueCallsModal let-modal>
    <div class="modal-box add-note-modal" cdkDrag>
        <div class="modal-header">
            <h5 class="modal-title">{{ 'OVERDUE_CALLS' | translate }}</h5>
            <button type="button" class="btn-close" [attr.aria-label]="'CLOSE' | translate" (click)="modal.dismiss()"></button>
        </div>
        <div class="modal-body">
            <div *ngIf="overdueCallsError" class="alert alert-warning mb-0">{{ overdueCallsError }}</div>
            <div *ngIf="!overdueCallsError && overdueCallsRows.length === 0" class="text-muted">{{ 'NO_OVERDUE_CALLS' | translate }}</div>
            <div *ngIf="!overdueCallsError && overdueCallsRows.length > 0" class="table-responsive">
                <table class="table-sm align-middle mb-0">
                    <thead><tr><th>{{ 'CLIENT' | translate }}</th><th>{{ 'TIER' | translate }}</th><th>{{ 'LAST_CALL' | translate }}</th><th>{{ 'DAYS_SINCE_CALL' | translate }}</th></tr></thead>
                    <tbody><tr *ngFor="let row of overdueCallsRows">
                        <td><span>{{ row.clientName }}</span><a *ngIf="row.clientId" target="_blank" href="/pages/client-details/{{ row.clientId }}" class="ms-1"><i class="fas fa-external-link-alt"></i></a></td>
                        <td>{{ row.tier }}</td>
                        <td>{{ row.lastCallDate ? (row.lastCallDate | date: 'mediumDate') : ('NEVER' | translate) }}</td>
                        <td>{{ row.daysSinceCall === null ? ('NEVER' | translate) : row.daysSinceCall }}</td>
                    </tr></tbody>
                </table>
            </div>
        </div>
        <div class="modal-footer"><button type="button" class="btn btn-outline-secondary" (click)="modal.close()">{{ 'CLOSE' | translate }}</button></div>
    </div>
</ng-template>
